import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TK } from '../../../core/i18n';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, RouterLink, TranslatePipe],
  template: `
    <footer>
      <div class="footer-content">
        <div class="footer-links">
          <a
            href="https://www.fraenkische.com/en/imprint"
            target="_blank"
            [innerHTML]="TK.footer.legalNotice | translate"
          ></a>
          <a
            href="https://www.fraenkische.com/en/privacy"
            target="_blank"
            [innerHTML]="TK.footer.dataProtection | translate"
          ></a>
          <a routerLink="/terms-of-use" [innerHTML]="TK.footer.termsOfUse | translate"></a>
          <div class="footer-brand">
            <a href="https://www.fraenkische.com" target="_blank">
              <img
                ngSrc="/images/frankische-logo.png"
                width="85"
                height="17"
                alt="Frankische Logo"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  `,
  styles: `
    .footer-content {
      margin-inline: auto;
      padding-inline: 1rem;
      display: flex;
      justify-content: flex-end;
      height: 3.5rem;

      .footer-links {
        display: flex;
        gap: 1.5rem;
        align-items: center;

        a {
          text-decoration: underline;
        }
        a:hover {
          color: var(--color-text-strong);
        }
      }
    }
  `,
})
export class Footer {
  protected readonly TK = TK;
}
